<template>
    <h2 class="heading" style="padding-left:90px;">Contract Agreement Log</h2>
    <div class="form">
        <el-form :model="contract" label-width="350px" style="width:1000px" >
            <el-form-item label="Nature" required>
                <el-select v-model="contract.nature" placeholder="Select Nature" style="width:220px;margin-right:10px;" tabindex="1">
                    <el-option v-for="nature in natures" :key="nature" :label="nature" :value="nature"/>
                    <el-option label="Others" value="Others"/>
                </el-select>
                <el-input v-model="contract.otherNature" v-if="contract.nature=='Others'" placeholder="Please specify other nature" 
                    style="width:410px; margin-left:10px;" maxlength="30"  show-word-limit="true" tabindex="2"/>
            </el-form-item>

            <el-form-item label="Service">
                <el-input v-model="contract.service" placeholder="Service" maxlength="100"  show-word-limit="true" tabindex="3"/>
            </el-form-item>

            <el-form-item label="Vendor Name" required>
                <el-input v-model="contract.vendorName" placeholder="Vendor Name" maxlength="20"  show-word-limit="true" tabindex="4"/>
            </el-form-item>

            <el-form-item label="Related ETFs">
                <el-select v-model="etf" placeholder="Select ETF" style="width:220px;margin-right:10px;" @change="selectETF" tabindex="5">
                    <el-option v-for="etf in allETFs" :key="etf" :label="etf" :value="etf"/>
                </el-select>
                <template v-if="contract.relatedETFs && contract.relatedETFs.length">
                    <el-tag v-for="etf in contract.relatedETFs.split(',')" :key="etf" @close="removeTag(etf)" closable>{{etf}}</el-tag>
                </template>
            </el-form-item>

            <el-form-item label="Status">
                <el-select v-model="contract.status" placeholder="Select Status" style="width:220px;margin-right:10px;" tabindex="5">
                    <el-option label="effective" value="effective"/>
                    <el-option label="expired" value="expired"/>
                    <el-option label="cancelled" value="cancelled"/>
                    <el-option label="ended" value="ended"/>
                </el-select>
            </el-form-item>

            <el-form-item label="Launch Date">
                <el-date-picker v-model="contract.launchDate" type="date" placeholder="Launch Date" value-format="YYYY-MM-DD" tabindex="6"/>
            </el-form-item>

            <el-form-item label="Agreement Date" required>
                <el-date-picker v-model="contract.agreementDate" type="date" placeholder="Agreement Date" value-format="YYYY-MM-DD" tabindex="7"/>
            </el-form-item>

            <el-form-item label="Effective Date" required>
                <el-date-picker v-model="contract.effectiveDate" type="date" placeholder="Effective Date" value-format="YYYY-MM-DD" tabindex="8"/>
            </el-form-item>

            <el-form-item label="Next Renewal Date">
                <el-date-picker v-model="contract.nextRenewalDate" type="date" placeholder="Next Renewal Date" value-format="YYYY-MM-DD" tabindex="9"/>
            </el-form-item>

            <el-form-item label="Next Date to Cancel">
                <el-date-picker v-model="contract.nextDateToCancel" type="date" placeholder="Next Date to Cancel" value-format="YYYY-MM-DD" tabindex="10"/>
            </el-form-item>

            <el-form-item label="Initial Term">
                <el-select v-model="contract.initialTerm" placeholder="Select Initial Term" style="width:220px;margin-right:10px;" tabindex="11">
                    <el-option v-for="term in allTerms" :key="term" :label="term" :value="term"/>
                </el-select>
            </el-form-item>

            <el-form-item label="Renewal Term">
                <el-select v-model="contract.renewalTerm" placeholder="Select Renewal Term" style="width:220px;margin-right:10px;" tabindex="12">
                    <el-option v-for="term in allTerms" :key="term" :label="term" :value="term"/>
                </el-select>
            </el-form-item>

            <el-form-item label="Notice Period for Termination">
                <el-input v-model="contract.noticePeriodForTermination" type="textarea" maxlength="500" rows="3" show-word-limit="true" tabindex="13"/>
            </el-form-item>

            <el-form-item label="Fee Calculation">
                <el-input v-model="contract.feeCalculation" type="textarea" maxlength="500" rows="3" show-word-limit="true" tabindex="14"/>
            </el-form-item>

            <el-form-item label="Fee per latest bills">
                <el-input v-model="contract.feePerLatestBills" type="textarea" maxlength="100" rows="3" show-word-limit="true" tabindex="14"/>
            </el-form-item>

            <el-form-item label="Contract Amount">
                <el-input-number v-model="contract.contractAmount" :min="0" :max="1000000" precision="2" controls-position="right"/>
            </el-form-item>

            <el-form-item label="Billed Amount">
                <el-input-number v-model="contract.billedAmount" :min="0" :max="1000000" precision="2" controls-position="right"/>
            </el-form-item>

            <el-form-item label="Currency" required>
                <el-select v-model="contract.currency" placeholder="Select Currency" style="width:220px;margin-right:10px;" tabindex="15">
                    <el-option v-for="ccy in allCurrencies" :key="ccy" :label="ccy" :value="ccy"/>
                </el-select>
            </el-form-item>

            <el-form-item label="Billing Frequency">
                <el-select v-model="contract.billingFrequency" placeholder="Select Billing Frequency" style="width:220px;margin-right:10px;" tabindex="16">
                    <el-option v-for="freq in allFrequencies" :key="freq" :label="freq" :value="freq"/>
                    <el-option label="Others" value="Others"/>
                </el-select>
                <el-input v-model="contract.otherFrequency" v-if="contract.billingFrequency=='Others'" placeholder="Please specify other frequency" 
                        style="width:410px; margin-left:10px;" maxlength="30" show-word-limit="true" tabindex="2"/>
            </el-form-item>

            <el-form-item label="Due Within">
                <el-input v-model="contract.dueWithin" type="textarea" maxlength="100" rows="3" show-word-limit="true"  tabindex="17" />
            </el-form-item>

            <el-form-item label="Overdue Penalty">
                <el-input v-model="contract.overduePenalty" type="textarea" maxlength="200" rows="3" show-word-limit="true"  tabindex="18" />
            </el-form-item>

            <el-form-item label="Contact Person">
                <el-input v-model="contract.contractPerson" placeholder="Contact Person" maxlength="30"  show-word-limit="true"  tabindex="19" />
            </el-form-item>

            <el-form-item label="Title">
                <el-input v-model="contract.title" placeholder="Title" maxlength="50"  show-word-limit="true" tabindex="20"/>
            </el-form-item>

            <el-form-item label="Email">
                <el-input v-model="contract.email" placeholder="Email" maxlength="100"  show-word-limit="true" tabindex="21" />
            </el-form-item>

            <el-form-item label="Memo">
                <el-input v-model="contract.memo" type="textarea" maxlength="200" rows="3" show-word-limit="true"  tabindex="18" />
            </el-form-item>

            <el-form-item label="">
                <el-button type="primary" @click="saveContract" style="margin-right:10px;" tabindex="22">Save Contract</el-button>
                <el-button @click="$router.push('/contract/allContracts')" tabindex="23">Cancel</el-button>
                <span class="errMsg" v-if="errMsg != ''">{{errMsg}}</span>
                <span v-if="loading" style="display:inline-block; margin-left:20px; vertical-align:middle;">
                    <img src="@/assets/loading.gif" style="height:24px;"/>
                </span>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>

import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'

export default {
    data() {
        return {
            allETFs : ["All", "2803", "3173", "3151", "3453", "9159", "3181", "2810", "2804", "3077", "9078", "2817", "9177", "3001", "3411", "3478", "Company"], 
            allTerms: ["3 Months", "6 Months", "1 Year", "2 Years", "3 Years", "4 Years", "5 Years", "7 Years", "10 Years", "15 Years"],
            allCurrencies: ["HKD", "USD", "RMB", "CNY", "EUR", "GBP", "JPY"],
            allFrequencies: ["Monthly", "Quarterly", "Annually", "One-off"],
            natures: ['Index provider', 'System vendor', 'Index Data', 'Market Data', 'Professional', 'Listing agent', 'Cleaning services', 'Trade matching'],
            etf : '',
            contract: {
                id: null,
                createTime: null,
                lastupdate: null,
                relatedETFs: "",
            },
            loading: false,
            files: '',
            errMsg: '',
            global,
        }
    },
    async mounted() {
        this.global.index = "contract";
        let code = this.$route.query ? this.$route.query.code : null;
        if (code) {
            let result = await AXIOS("/contract/getContract", {code: code});
            if (result.success) {
                this.contract = result.data;
            } else {
                this.errMsg = result.errMsg;
            }
        }
    },
    methods: {
        selectETF() {
            if (this.etf == 'All') {
                this.contract.relatedETFs = "All";
                return;
            } else if (this.contract.relatedETFs == 'All') {
                this.contract.relatedETFs = this.etf;
                return;
            }

            if (this.contract.relatedETFs.indexOf(this.etf) == -1) {
                this.contract.relatedETFs = (this.contract.relatedETFs == '') ? this.etf : 
                    this.contract.relatedETFs + "," + this.etf;
            }
        },
        removeTag(etf) {
            let etfs = (this.contract.relatedETFs + ",").replace(etf+",", "")
            this.contract.relatedETFs = (etfs.length > 0) ? etfs.substring(0, etfs.length-1) : "";
        },
        async saveContract() {
            this.errMsg = "";
            if (!this.contract.nature) {
                this.errMsg = "[Nature] is required"; return;
            }
            if (!this.contract.agreementDate) {
                this.errMsg = "[Agreement Date] is required"; return;
            }
            if (!this.contract.vendorName) {
                this.errMsg = "[Vendor Name] is required"; return;
            }
            if (!this.contract.effectiveDate) {
                this.errMsg = "[Effective Date] is required"; return;
            }
            this.contract.lastupdate = null;
            if (this.contract.nature == "Others")
                this.contract.nature = this.contract.otherNature;

            if (this.contract.billingFrequency == "Others")
                this.contract.billingFrequency = this.contract.otherFrequency

            if (this.loading) return;
            this.loading = true;

            let result = await AXIOS("/contract/saveContract", this.contract);
            if (result.success) {
                this.$router.push("/contract/allContracts");
            } else {
                this.errMsg = result.errMsg;
            }
            this.loading = false;
        }
    }
}
</script>

<style scoped>
    .heading {
        width:900px;
    }
    .errMsg {
        padding-left:10px;
    }
    .el-tag a {cursor:pointer;}
</style>